import {
  SAVE_TASKS,
  SAVE_TASKS_ALL,
  SAVE_ISSUES,
  SAVE_ISSUES_ALL,
  SAVE_DATAPICK_TASKS,
  SAVE_DATAPICK_TASKS_ALL,
  SAVE_INSTALLATION_DOCUMENT_TASKS,
  SAVE_INSTALLATION_DOCUMENT_TASKS_ALL,
} from '../actions/servicereport';

const defaultState = {
  tasks: -1,
  tasksAll: [],
  issues: -1,
  issuesAll: [],
  datapickTasks: -1,
  datapickTasksAll: [],
  installationDocumentTasks: -1,
  installationDocumentTasksAll: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SAVE_TASKS: {
      if (action.tasks) {
        return { ...state, tasks: action.tasks };
      }
      break;
    }
    case SAVE_TASKS_ALL: {
      if (action.tasksAll) {
        return { ...state, tasksAll: action.tasksAll };
      }
      break;
    }
    case SAVE_ISSUES: {
      if (action.issues) {
        return { ...state, issues: action.issues };
      }
      break;
    }

    case SAVE_ISSUES_ALL: {
      if (action.issuesAll) {
        return { ...state, issuesAll: action.issuesAll };
      }
      break;
    }

    case SAVE_DATAPICK_TASKS: {
      if (action.datapickTasks) {
        return { ...state, datapickTasks: action.datapickTasks };
      }
      break;
    }

    case SAVE_DATAPICK_TASKS_ALL: {
      if (action.datapickTasksAll) {
        return { ...state, datapickTasksAll: action.datapickTasksAll };
      }
      break;
    }

    case SAVE_INSTALLATION_DOCUMENT_TASKS: {
      if (action.installationDocumentTasks) {
        return { ...state, installationDocumentTasks: action.installationDocumentTasks };
      }
      break;
    }

    case SAVE_INSTALLATION_DOCUMENT_TASKS_ALL: {
      if (action.installationDocumentTasksAll) {
        return { ...state, installationDocumentTasksAll: action.installationDocumentTasksAll };
      }
      break;
    }

    default:
  }

  return state;
};
